import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'

import './style.scss'

export default class GroupEntityPreview extends Component {
    static propTypes = {
        count: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            animate: false,
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ animate: true })
        }, 0)
    }

    render() {
        const { count, name } = this.props
        const { animate } = this.state

        return (
            <div className={cx('group-entity-wrap preview', animate && 'animate')}>
                <div className={'icon'} />
                <div className={'texts'}>
                    <div className={'name'}>{name}</div>
                    <div className={'count'}>
                        <FormattedMessage id={'components.GroupEntity.members'} values={{ memberCount: count }} />
                    </div>
                </div>
            </div>
        )
    }
}
